/**
 * CMS theme resolution (config values overridden by the CMS page theme).
 *
 * ⚠️ No imports (used by global components at bootstrap): relies on the
 * global `get_config` mixin and on `this.$store` when present.
 */

/**
 * When false the CMS page `theme` (colors, header logo) is ignored and the
 * config values are used.
 * TODO: disabled until the CMS theme handling is defined.
 */
export const CMS_THEME_ENABLED = false;

const DEFAULT_LOGO_ALT = 'logo';

/** Config colors overridden by the CMS theme ones. */
export const resolve_theme_colors = (config_colors, cms_theme) => ({
  ...(config_colors || {}),
  ...((cms_theme || {}).colors || {}),
});

/** Header logo: the CMS theme one, else the config one (`mainLogo` url). */
export const resolve_main_logo = (config_logo, cms_theme) => {
  const { logo } = cms_theme || {};
  if (logo && logo.url) {
    return { url: logo.url, alt: logo.alt || DEFAULT_LOGO_ALT };
  }
  return config_logo ? { url: config_logo, alt: DEFAULT_LOGO_ALT } : null;
};

/**
 * Component mixin exposing the active `theme_colors` and `main_logo`
 * (reactive on the store `cms_theme`).
 */
export const theme_mixin = {
  computed: {
    // guarded: components may be mounted in instances without the store
    cms_theme() {
      return (this.$store && this.$store.state.cms_theme) || null;
    },
    theme_colors() {
      return resolve_theme_colors(
        this.get_config('guiSettings.customizations.colors', null),
        this.cms_theme
      );
    },
    main_logo() {
      return resolve_main_logo(
        this.get_config('guiSettings.customizations.mainLogo', false),
        this.cms_theme
      );
    },
  },
};
